import { render } from "./TheTieuChuanKhachSan.vue?vue&type=template&id=0b17e65c"
import script from "./TheTieuChuanKhachSan.vue?vue&type=script&lang=js"
export * from "./TheTieuChuanKhachSan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__